import { Component, Input } from '@angular/core';


@Component({
  selector: 'ui-card',
  standalone: true,
  imports: [],
  templateUrl: './ui-card.component.html',
  styleUrl: './ui-card.component.scss'
})
export class UiCardComponent {
  @Input() padding: 'none' | 'sm' | 'md' | 'lg' = 'md';
  @Input() shadow = true;
  @Input() bordered = true;

  /** Additional CSS classes applied to the outer card wrapper. */
  @Input() className = '';

  get computedClasses(): string {
    const classes = ['card', 'bg-base-100'];

    if (this.shadow) {
      classes.push('shadow-md');
    }

    if (this.bordered) {
      classes.push('border', 'border-base-300');
    }

    if (this.className) {
      classes.push(this.className);
    }

    return classes.join(' ');
  }

  get bodyClasses(): string {
    const classes = ['card-body'];

    if (this.padding === 'none') {
      classes.push('p-0');
    } else if (this.padding === 'sm') {
      classes.push('p-3');
    } else if (this.padding === 'lg') {
      classes.push('p-6');
    }
    // md is default in DaisyUI

    return classes.join(' ');
  }
}
